import {
  handleSocketFasErrorEvent,
  handleSocketFasSuccessEvent,
  handleSocketFasReversalErrorEvent,
  handleSocketFasReversalSuccessEvent,
} from './actions';
import queryClient from '../../react-query-client';
import { sanitizeSocketMessage } from '../../utils/error-sanitizer';

/**
 * Consumed by Socket context to register listeners
 */
const residentProfileSocketHandlers = (dispatch, socket) => {
  socket.on('fas.success', (message) => {
    const {
      file: { data: fileData, name: fileName },
      payload: { applicationId, customerId, residentId },
    } = message;
    const payload = {
      applicationId,
      customerId,
      fileData,
      fileName,
      residentId,
    };
    dispatch(handleSocketFasSuccessEvent(payload));
  });

  socket.on('fas.error', (message) => {
    // Sanitize the error message to prevent React serialization issues
    const sanitizedMessage = sanitizeSocketMessage(message);
    dispatch(handleSocketFasErrorEvent(sanitizedMessage));
  });

  socket.on('createFinalAccountStatementReversal.success', (message) => {
    refreshCollections();
    dispatch(handleSocketFasReversalSuccessEvent(message));
  });

  socket.on('createFinalAccountStatementReversal.error', (message) => {
    // Sanitize the error message to prevent React serialization issues
    const sanitizedMessage = sanitizeSocketMessage(message);
    dispatch(handleSocketFasReversalErrorEvent(sanitizedMessage));
  });
};

export default residentProfileSocketHandlers;

const refreshCollections = () => {
  queryClient.invalidateQueries('householdCollection');
  queryClient.invalidateQueries('claim');
};
